import ImageCompare from "image-compare-viewer";

const compare = () => {
  if (document.querySelector(".js-compare-image")) {
    const element = document.querySelector(".js-compare-image");
    new ImageCompare(element, {
      controlShadow: true,
      addCircle: true,
      addCircleBlur: true,
    }).mount();
  }
};

export default compare;
